var render = function render(){var _vm=this,_c=_vm._self._c;return _c('cadastrar-regiao',{attrs:{"action":"Editar","regiaoASerEditada":_vm.regiaoASerEditada},on:{"close":_vm.close,"editar":_vm.save}})
}
var staticRenderFns = []

export { render, staticRenderFns }